export default {
    name: "inputWidth",
    bind(el, binding) {
        const defaultWidth = binding.value?.defaultWidth || 220;
        const focusWidth = binding.value?.focusWidth || 360;
        const transition = binding.value?.transition || 0.3;

        el.style.width = defaultWidth + 'px';
        el.style.transition = `width ${transition}s ease`;

        const inputEl = el.querySelector('input');
        if(inputEl) {
            inputEl.addEventListener('focus', () => {
                el.style.width = focusWidth + 'px';
            });

            inputEl.addEventListener('blur', () => {
                setTimeout(() => {
                    el.style.width = defaultWidth + 'px';
                }, transition * 1000);
            });
        }
    }
};
